import React from "react";
import CacheBuster from "./CacheBuster.js";
import { Route, Switch, Router, Redirect } from "react-router-dom";
import history from "./history.js";
import { Helmet } from "react-helmet";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import Menu from "./header/Menu.jsx";
import "../src/assets/css/reactMaterial.css";
import "../src/assets/css/icon.css";
import "./assets/css/dk.css";
import b2cmenu from "./data/b2cmenu.json";
import b2bmenu from "./data/b2bmenu.json";
import b2smenu from "./data/b2smenu.json";
import videomenu from "./data/videomenu.json";
import mcwmenu from "./data/mcwmenu.json";

import { fetchLogin } from "./redux/actions/loginActions.js";

export default function App() {

  const dispatch = useDispatch(); 
  dispatch(fetchLogin()); 
  
  const loginNameState = useSelector(
    state => state.loginReducer.loginName,
    shallowEqual
  );

  const UserData = JSON.parse(localStorage.getItem('UserData'));
  const isLoggedIn = loginNameState && loginNameState != "" ? true : true;


  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          <>
            <Helmet
              titleTemplate="%s | Avetti Support"
              defaultTitle="Avetti Support"
            >
              <meta
                name="description"
                content="Avetti Support"
              />
            </Helmet>
            <Router history={history}>

              <Switch>

                <Route
                  exact
                  path="/"
                  render={routeProps => {
                    return (
                      <>
                        <Menu {...routeProps} component="home" />
                      </>
                    );
                  }}
                />
                <Route
                  exact
                  path={"/marketplacepage/"}
                  render={routeProps => {
                    return (
                      <>
                        <Menu {...routeProps} component="marketplacepage" />
                      </>
                    );
                  }}
                />
                <Route
                  exact
                  path={"/b2c/"}
                  render={routeProps => (
                    isLoggedIn ?
                      <Menu {...routeProps} component="b2c" />
                      :
                      <Redirect to="/login" />
                  )}
                />
                <Route
                  exact
                  path={"/b2b/"}
                  render={routeProps => (
                    <Menu {...routeProps} component="b2b" />
                  )}
                />
                <Route
                  exact
                  path={"/b2s/"}
                  render={routeProps => (
                    <Menu {...routeProps} component="b2s" />
                  )}
                />
                 <Route
                  exact
                  path={"/mcw/"}
                  render={routeProps => (
                    <Menu {...routeProps} component="mcw" />
                  )}
                />

                {
                  Object.keys(b2cmenu) &&
                  Object.keys(b2cmenu).length > 0 &&
                  Object.keys(b2cmenu).map((propname, i) => {
                    const subCat = b2cmenu[propname].subCat;
                    const link = "/b2c/" + propname;
                    const catName = b2cmenu[propname].catName;
                    console.log(propname, link)
                    return (
                      <Route
                        key={i}
                        exact
                        path={link}
                        render={routeProps => (
                          isLoggedIn ?
                            <Menu {...routeProps} catName={catName} component={propname} />
                            :
                            <Redirect to="/login" />
                        )}
                      />
                    )
                  })
                }
                {
                  Object.keys(b2cmenu) &&
                  Object.keys(b2cmenu).length > 0 &&
                  Object.keys(b2cmenu).map((propname, i) => {
                    const subCat = b2cmenu[propname].subCat;
                    const link = "/b2c/" + propname;
                    return (
                      Object.keys(subCat).map((propname, i) => {
                        const catName = subCat[propname].subcatName;
                        return (
                          <Route
                            key={i}
                            exact
                            path={link + "/" + propname}
                            render={routeProps => (
                              isLoggedIn ?
                                <Menu {...routeProps} catName={catName} component={propname} />
                                :
                                <Redirect to="/login" />
                            )}
                          />
                        )
                      })
                    )
                  })
                }

                {
                  Object.keys(videomenu) &&
                  Object.keys(videomenu).length > 0 &&
                  Object.keys(videomenu).map((propname, i) => {
                    const subCat = videomenu[propname].subCat;
                    const link = "/VideoTutorials/" + propname;
                    const catName = videomenu[propname].catName;
                    console.log("VideoTutorialsPage",propname, link)
                    return (
                      <Route
                        key={i}
                        exact
                        path={link}
                        render={routeProps => (
                          <Menu {...routeProps} catName={catName} subCat={subCat} component={`VideoTutorials`}/>

                        )}
                      />
                    )
                  })
                }

                {
                  Object.keys(videomenu) &&
                  Object.keys(videomenu).length > 0 &&
                  Object.keys(videomenu).map((propname, i) => {
                    const subCat = videomenu[propname].subCat;
                    const link = "/VideoTutorials/" + propname;
                    return (
                      Object.keys(subCat).map((propname, i) => {
                        const catName = subCat[propname].subcatName;
                        const catData = subCat[propname];
                        return (
                          <Route
                            key={i}
                            exact
                            path={link + "/" + propname}
                            render={routeProps => (
                              isLoggedIn ?
                                <Menu {...routeProps} catName={catName} {...catData} component={`videoTutorialComponent`} />
                                :
                                <Redirect to="/login" />
                            )}
                          />
                        )
                      })
                    )
                  })
                }
                 {
                  Object.keys(videomenu) &&
                  Object.keys(videomenu).length > 0 &&
                  Object.keys(videomenu).map((propname, i) => {
                    const subCat = videomenu[propname].subCat;
                    const link = "/b2c/" + propname;
                    const catName = videomenu[propname].catName;
                    console.log(propname, link)
                    return (
                      <Route
                        key={i}
                        exact
                        path={link}
                        render={routeProps => (
                          isLoggedIn ?
                            <Menu {...routeProps} catName={catName} component={propname} />
                            :
                            <Redirect to="/login" />
                        )}
                      />
                    )
                  })
                }

                <Route
                  exact
                  path={"/docs/"}
                  render={routeProps => (
                    isLoggedIn ?
                      <Menu {...routeProps} component="docs" />
                      :
                      <Redirect to="/login" />
                  )}
                />

                <Route
                  exact
                  path={"/login"}
                  render={routeProps => (
                    <Menu {...routeProps} component="login" />
                  )}
                />

                <Route
                  exact
                  path={"/VideoTutorials/"}
                  render={routeProps => (      
                    isLoggedIn ?
                    <Menu {...routeProps} component="VideoTutorials" />
                      :
                      <Redirect to="/login" />
                  )}
                />
                <Route
                  exact
                  path={"/Product-Video/"}
                  render={routeProps => (
                    <Menu {...routeProps} component="ProductVideo" />
                  )}
                />
                <Route
                  exact
                  path={"/ItemPropertiesVideo/"}
                  render={routeProps => (
                    <Menu {...routeProps} component="ItemPropertiesVideo" />
                  )}
                />

                <Route
                  exact
                  path={"/ManageFacetsVideo/"}
                  render={routeProps => (
                    <Menu {...routeProps} component="ManageFacetsVideo" />
                  )}
                />
              {
                  Object.keys(b2bmenu) &&
                  Object.keys(b2bmenu).length > 0 &&
                  Object.keys(b2bmenu).map((propname, i) => {
                    const subCat = b2bmenu[propname].subCat;
                    const link = "/b2b/" + propname;
                    const catName = b2bmenu[propname].catName;
                    return (
                      <Route
                        key={i}
                        exact
                        path={link}
                        render={routeProps => (
                          isLoggedIn ?
                            <Menu {...routeProps} catName={catName} component={propname} />
                            :
                            <Redirect to="/login" />
                        )}
                      />
                    )
                  })
                }
                {
                  Object.keys(b2bmenu) &&
                  Object.keys(b2bmenu).length > 0 &&
                  Object.keys(b2bmenu).map((propname, i) => {
                    const subCat = b2bmenu[propname].subCat;
                    const link = "/b2b/" + propname;
                    return (
                      Object.keys(subCat).map((propname, i) => {
                        const catName = subCat[propname].subcatName;
                        return (
                          <Route
                            key={i}
                            exact
                            path={link + "/" + propname}
                            render={routeProps => (
                              isLoggedIn ?
                                <Menu {...routeProps} catName={catName} component={propname} />
                                :
                                <Redirect to="/login" />
                            )}
                          />
                        )
                      })
                    )
                  })
                }
                {
                  Object.keys(b2smenu) &&
                  Object.keys(b2smenu).length > 0 &&
                  Object.keys(b2smenu).map((propname, i) => {
                    const subCat = b2smenu[propname].subCat;
                    const link = "/b2s/" + propname;
                    const catName = b2smenu[propname].catName;
                    return (
                      <Route
                        key={i}
                        exact
                        path={link}
                        render={routeProps => (
                          isLoggedIn ?
                            <Menu {...routeProps} catName={catName} component={propname} />
                            :
                            <Redirect to="/login" />
                        )}
                      />
                    )
                  })
                }
                {
                  Object.keys(b2smenu) &&
                  Object.keys(b2smenu).length > 0 &&
                  Object.keys(b2smenu).map((propname, i) => {
                    const subCat = b2smenu[propname].subCat;
                    const link = "/b2s/" + propname;
                    return (
                      Object.keys(subCat).map((propname, i) => {
                        const catName = subCat[propname].subcatName;
                        return (
                          <Route
                            key={i}
                            exact
                            path={link + "/" + propname}
                            render={routeProps => (
                              isLoggedIn ?
                                <Menu {...routeProps} catName={catName} component={propname} />
                                :
                                <Redirect to="/login" />
                            )}
                          />
                        )
                      })
                    )
                  })
                }
                {
                  Object.keys(mcwmenu) &&
                  Object.keys(mcwmenu).length > 0 &&
                  Object.keys(mcwmenu).map((propname, i) => {
                    const subCat = mcwmenu[propname].subCat;
                    const link = "/mcw/" + propname;
                    const catName = mcwmenu[propname].catName;
                    return (
                      <Route
                        key={i}
                        exact
                        path={link}
                        render={routeProps => (
                          isLoggedIn ?
                            <Menu {...routeProps} catName={catName} component={propname} />
                            :
                            <Redirect to="/login" />
                        )}
                      />
                    )
                  })
                }
                {
                  Object.keys(mcwmenu) &&
                  Object.keys(mcwmenu).length > 0 &&
                  Object.keys(mcwmenu).map((propname, i) => {
                    const subCat = mcwmenu[propname].subCat;
                    const link = "/mcw/" + propname;
                    return (
                      Object.keys(subCat).map((propname, i) => {
                        const catName = subCat[propname].subcatName;
                        return (
                          <Route
                            key={i}
                            exact
                            path={link + "/" + propname}
                            render={routeProps => (
                              isLoggedIn ?
                                <Menu {...routeProps} catName={catName} component={propname} />
                                :
                                <Redirect to="/login" />
                            )}
                          />
                        )
                      })
                    )
                  })
                }
              </Switch>
            </Router>
          </>
        );
      }}
    </CacheBuster>
  );
}
